<template>
  <div>
    <!-- 移动文件弹窗 -->
    <el-dialog title='请选择移动路径' :visible.sync="moveResourceVisible" custom-class="dialog-form" @open="moveResourceDialogOpened"
       :before-close="handleResourceDialogClose" :close-on-click-modal="false">
      <el-form :model="moveForm" ref="moveForm" label-width="auto" label-position="right" @submit.native.prevent>
        <el-form-item label="" >
          <div style="width: 652px;height:239px;margin: 0 auto;overflow: auto;background-color: #F5F7FA;">
            <div style="min-width: 644px; width: fit-content;">
              <el-tree ref="resMoveTree" :props="defaultProps" :data="folderList" node-key="id" class="course-tree" icon-class="iconfont icon-arrow-right mini" :default-expanded-keys="[0]"
                       :highlight-current='true' @node-click="handleNodeClick" style="background-color: #F5F7FA;" lazy :load="loadNode" @node-expand="handleNodeExpand" @node-collapse="handleNodeCollapse">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>
                     <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icon-content-courses"></use>
                     </svg>
                     <span class="res-move-folder-edit-panel" style="position: relative;" v-if="data.showInput">
                         <el-input size="mini" ref="editNodeInput"  v-model="editNodeInputVal" class="edit-node-input" maxlength="198"
                                   @click.stop.native @focus="focusEditNodeInput($event)" @blur="blurEditNodeInput(node, data, false)"
                                   @input.native="inpEditNodeInput" @keyup.enter.native="blurEditNodeInput(node, data, true)"></el-input>
                       <div class="custom--input-error-tip" v-if="editCellToolTipVisible && editCellErrorTip != ''"><span class="arrow"></span><span v-html="editCellErrorTip"></span></div>
                       <el-button class="custom-icon-button " icon="iconfont icon-others_res_check mini" @click.stop.native="submitEditNodeInput(data)" style="margin-left: 5px; vertical-align: middle;" title="确定"></el-button>
                       <el-button class="custom-icon-button cancel-edit-mode" icon="iconfont icon-others_res_cross mini" @click.stop.native="cancelEditNodeInputModel(data)" style="margin-left: 5px; vertical-align: middle;" title="取消"></el-button>
                     </span>
                    <span class="label" :title="node.label" v-else>{{ node.label }}</span>
                  </span>
              </span>
              </el-tree>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain style="float:left" icon="el-icon-plus" @click.stop="createNewFolder()" :disabled="editNodeInputVisible">新建文件夹</el-button>
        <el-button @click.stop="handleResourceDialogClose()">取 消</el-button>
        <el-button type="primary" @click.stop="submitMoveResourceForm()" :disabled="editNodeInputVisible">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 重名文件弹窗 -->
    <el-dialog title='保留或跳过文件' :visible.sync="confirmRepeatDialogVisible" custom-class="dialog-form confirm-repeat-dialog" @open="confirmRepeatDialogOpened">
      <div class="repeat-dialog-content-panel">
        目标已包含{{fileRepeatList.length}}个同名文件，<el-link style="color:#258CE6" :underline="false" @click="toggleRepeatFileList()">查看详情 <i :class="'iconfont '+ (repeatFileListVisible ? 'icon-arrow-up' : 'icon-arrow-down')+ ' mini'"></i></el-link>
        <div class="repeat-file-list-panel" v-if="repeatFileListVisible">
          <div class="repeat-file-item" :title="item.name + (item.isDir ? '' : '.'+item.suffix)" v-for="item in fileRepeatList" :key="item.id">{{item.name}}<span v-if="item.isDir == false">.{{item.suffix}}</span></div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="submitConfirmRepeatForm()">全部保留移动</el-button>
        <el-button type="primary" @click="closeRepeatConfirmDialog()">跳过同名文件</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {fmtInvalidFileName, validateFileName} from "../../../../common-components/src/utils/fileUtil";

export default {
  name: "ResourceMove",
  props: {
    parentId: Number,
    backOptDuration:Number,
    notifyMsgCache: Object,
    moveForm: Object
  },
  data(){
    return {
      folderId:0,
      selectedIds:[],
      moveResourceVisible: false,
      folderList: [],
      selectNodeId:0,
      treeNodeMap:{},
      successList:[],
      fileRepeatList:[],
      defaultProps: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      },

      confirmRepeatDialogVisible:false,
      repeatFileListVisible:false,

      editNodeInputVal:'',
      editNodeInputSaved:false,
      editNodeInputVisible:false,
      editNodeItem: null,
      editCellFocus:false,
      editCellErrorTip:'',
      editCellToolTipTimer:0,
      editCellToolTipVisible:false
    }
  },
  methods: {
    closeAllNotify(params) {
      this.$emit('closeAllNotify', params)
    },
    refreshFiles(params) {
      this.$emit('refreshFiles', params)
    },
    multipleMove(parentId, selectedIds) {
      // console.log(parentId, selectedIds, new Date());
      this.parentId = parentId;
      this.selectedIds = selectedIds;
      this.successList=[];
      this.fileRepeatList = [];
      this.treeNodeMap = {}
      this.moveResourceVisible = true;
      this.editNodeInputSaved = false
      this.resetNodeInputEditFlag()
      this.confirmRepeatDialogVisible = false;

      // 默认选中根节点
      this.$nextTick(() => {
        this.$refs.resMoveTree.setCurrentKey(0)
      })
    },
    handleResourceDialogClose(done) {
      try {
        if(this.editNodeInputSaved) {
          this.refreshFiles()
        }
      } catch (e) {
        console.error(e)
      } finally {
        if(typeof (done) == "function") {
          done();
        } else {
          this.moveResourceVisible = false
        }
      }
    },
    moveResourceDialogOpened() {
      // console.log('moveResourceDialogOpened - 1', new Date())
      let rootNode = {id:0, label: '全部文件', showInput:false, children: [], isLeaf: false};
      this.folderList =  [rootNode];
    },
    handleNodeClick(data){
      if (this.moveForm.id !== data.id){
        if(typeof (this.$refs.resMoveTree.store.nodesMap[data.id]) != "undefined") {
          this.$refs.resMoveTree.store.nodesMap[data.id].expanded = true;
        }
      }
      this.moveForm.id = data.id;
      this.moveForm.name = data.name;
    },
    resetMoveTreeCurrentNode(nodeId) {
      try {
        let currentKey = this.$refs.resMoveTree.getCurrentKey()
        if (currentKey == null || currentKey != nodeId) {
          this.$nextTick(() => {
            this.$refs.resMoveTree.setCurrentKey(nodeId)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    handleNodeExpand(data){
      // console.log('handleNodeExpand', data.id, new Date());
      this.resetMoveTreeCurrentNode(data.id)
    },
    handleNodeCollapse(data) {
      // console.log('handleNodeCollapse', data, new Date());
      this.resetMoveTreeCurrentNode(data.id)
    },
    queryResourceList(folderId, node, resolve) {
      let params = {};
      params.parentId = folderId;
      this.$api.get("/resapi/tw/resource-file/queryDirs", {params: params}).then(res => {
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        // console.log('queryDirs', res, new Date());
        this.convertTreeData(res.data, folderId, node, resolve);
      }).catch(error => {
        console.error(error);
      })
    },
    loadNode (node, resolve) {
      // console.log('loadNode', node.data.id, node.level, typeof (resolve),new Date());
      if(node.level == 0) {
        return resolve(this.folderList)
      } else  {
        this.queryResourceList(node.data.id, node, resolve);
      }
    },
    convertTreeData(zNodes, folderId, parentNode, resolve) {
      if (typeof (parentNode) == "undefined" || parentNode == null) {
        return;
      }
      parentNode.children = [];
      let data = parentNode.children;
      for(let i = 0;i < zNodes.length;i++) {
        let zNode = zNodes[i];
        let treeNode = this.convertZNode2TreeNode(zNode);
        this.treeNodeMap[zNode.id] = treeNode;
        data.push(treeNode)
      }
      if(typeof (resolve) != "undefined") {
        return resolve(data);
      }
    },
    convertZNode2TreeNode(zNode) {
      let isLeaf = (zNode.isDir == 0 || zNode.childNode == null || zNode.childNode.length == 0)
      let node =  {id: zNode.id, label: zNode.name, 'showInput':false, children:[], isLeaf: isLeaf};
      return node;
    },
    submitMoveResourceForm() {
      let nodeId = this.$refs.resMoveTree.getCurrentKey();
      // console.log('submitMoveResourceForm move', ' selectedIds=', this.selectedIds,  'to', nodeId,new Date())
      this.selectNodeId = nodeId;
      this.moveCheck(nodeId, this.selectedIds)
    },
    outerMoveCheck(parentId, selectedIds) {
      if(this.selectNodeId != parentId) {
        this.selectNodeId = parentId
      }
      this.selectedIds = selectedIds;
      this.moveCheck(parentId, selectedIds)
    },
    moveCheck(parentId, selectedIds) {
      let ids = selectedIds.join(',')
      let params = {parentId:parentId, 'ids': ids};
      this.ucloading.showLoading();
      this.$api.post("/resapi/tw/resource-file/moveCheck", params).then(res => {
        this.ucloading.hideLoading();
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        if(res.data) {
          this.moveResourceVisible = false;
          this.successList = res.data.successList;
          if (res.data.fileRepeatList.length > 0){
            this.fileRepeatList = res.data.fileRepeatList;
            this.confirmRepeatDialogVisible = true;
          } else {
            this.move(parentId, selectedIds)
          }
        }
      }).catch(error => {
        console.error(error);
        this.ucloading.hideLoading();
      })
    },
    move(parentId, selectedIds) {
      let ids = selectedIds.join(',')
      let params = {parentId:parentId, 'ids': ids};
      this.ucloading.showLoading();
      this.$api.post("/resapi/tw/resource-file/move", params).then(res => {
        this.ucloading.hideLoading();
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        this.refreshFiles()
        if(res.data.successList.length > 0) {
          this.successList = res.data.successList;
          this.confirmMoveBack()
        }
      }).catch(error => {
        console.error(error);
        this.ucloading.hideLoading();
      })
    },
    confirmRepeatDialogOpened() {
      this.repeatFileListVisible=false
    },
    toggleRepeatFileList() {
      this.repeatFileListVisible=!this.repeatFileListVisible;
    },
    closeRepeatConfirmDialog() {
      this.confirmRepeatDialogVisible = false;
      this.move(this.selectNodeId, this.selectedIds)
    },
    submitConfirmRepeatForm() {
      this.moveRepeat(this.selectNodeId)
    },
    confirmMoveBack() {
      const h = this.$createElement;
      const notifyId = 'notification-move-back_' + new Date().getTime();
      const notity = this.$messageZ.success({
        title: '提示',
        message: h("p", null, [
              h("span", null, '文件移动成功'),
              h("a", {class: "notification-view-detail notification-edit-back", on: {click: this.moveBack}}, "撤回移动"),
            ]
        ),
        duration: this.backOptDuration
      });
      this.notifyMsgCache[notifyId] = notity;
    },
    moveRepeat(parentId) {
      let ids =  this.selectedIds.join(',');
      let params = {parentId:parentId, 'ids': ids};
      this.ucloading.showLoading();
      this.$api.post("/resapi/tw/resource-file/moveRepeat", params).then(res => {
        this.ucloading.hideLoading();
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        this.confirmRepeatDialogVisible = false;
        if(res.data.successList.length > 0) {
          this.successList = res.data.successList;
          this.confirmMoveBack()
        }
        this.refreshFiles()
      }).catch(error => {
        console.error(error);
        this.ucloading.hideLoading();
        this.refreshFiles()
      })
    },
    moveBack() {
      this.closeAllNotify();
      this.ucloading.showLoading();
      this.$api.post("/resapi/tw/resource-file/moveBack", this.successList, {headers: {'Content-Type': 'application/json'}}).then(res => {
        this.ucloading.hideLoading();
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        this.$message.success('撤回移动成功');
        this.refreshFiles()
      }).catch(error => {
        console.error(error);
        this.ucloading.hideLoading();
        this.refreshFiles()
      })
    },
    createNewFolder() {
      let currentNodeData = this.$refs.resMoveTree.getCurrentNode();
      if(typeof (currentNodeData) == "undefined" || currentNodeData == null) {
        return;
      }
      let nodeId = (typeof (currentNodeData.nodeId) != "undefined") ? currentNodeData.nodeId : currentNodeData.id;
      let parentNode = this.$refs.resMoveTree.getNode(nodeId)
      if(typeof (parentNode) == "undefined" || parentNode == null) {
        return;
      }
      if(!parentNode.expanded) {
        parentNode.expanded = true
      }
      if (!parentNode.data.children) {
        this.$set(parentNode.data, 'children', []);
      }
      let st = new Date().getTime() * -1;
      let parentId = (typeof (parentNode.data) != "undefined" && parentNode.data != null) ? parentNode.data.id : parentNode.id;
      let params = {parentId:parentId, name: '新建文件夹'};
      this.ucloading.showLoading();
      this.$api.get("/resapi/tw/resource-file/getDirName", {params: params}).then(res => {
        this.ucloading.hideLoading();
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        // console.log('getDirName', res.data, new Date())
        if(res.data) {
          let folderName = res.data
          let newFolderNode = {id: st, parentId:parentId, name: folderName, isNew:true}
          let newChild = this.convertZNode2TreeNode(newFolderNode);
          newChild.parentId = parentId;
          newChild.isNew = true
          newChild.isLeaf = true;
          if (!parentNode.data.children) {
            this.$set(parentNode.data, 'children', []);
          }
          parentNode.data.children.unshift(newChild);
          parentNode.isLeaf = false
          parentNode.loaded = true
          parentNode.expand()
          this.$nextTick(() => {
            this.enterEditNode(newChild);
            this.moveForm.id = newChild.id
            this.$refs.resMoveTree.setCurrentKey(newChild.id)
          })
        }
      }).catch(error => {
        console.error(error);
        this.ucloading.hideLoading();
      })
    },
    forceForceEditInput(selectFlag) {
      /* 聚焦input框 */
      if (typeof (selectFlag) == "undefined" || selectFlag == null) {
        selectFlag = false
      }
      let vm = this;
      this.$nextTick(function() { // //DOM 更新了
        if(typeof (vm.$refs.editNodeInput) != "undefined") {
          if (selectFlag) {
            vm.$refs['editNodeInput'].select();
          }
          vm.$refs.editNodeInput.focus();
        }
      });
    },
    submitEditNodeInput(data) {
      this.execTreeNodeRename(this.editNodeInputVal, data)
    },
    cancelEditNodeInputModel(data) {
      let newParentId = 0
      let parentNode = null
      try {
        let editNode = this.$refs.resMoveTree.getNode(data.id)
        if(typeof (editNode) == "undefined" || editNode == null || typeof (editNode.parent) == "undefined") {
          return;
        }
        parentNode = editNode.parent
        if(parentNode) {
          let targetNodeId = editNode.id;
          let children = parentNode.childNodes;
          let index = children.findIndex(d => d.id === targetNodeId);
          if(index != -1) {
            children.splice(index, 1);
          }
          if(typeof (parentNode.children) != "undefined") {
            children = parentNode.children;
            index = children.findIndex(d => d.id ===targetNodeId);
            if(index != -1) {
              children.splice(index, 1);
            }
          }
          if(typeof (parentNode.data) != "undefined") {
            targetNodeId = editNode.data.id;
            newParentId = typeof (parentNode.data.nodeId) != "undefined" ? parentNode.data.nodeId : parentNode.data.id;
            children = parentNode.data.children;
            index = children.findIndex(d => (d.id === targetNodeId || d.nodeId === targetNodeId));
            if(index != -1) {
              children.splice(index, 1);
            }
          }
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.$nextTick(() => {
          this.$refs.resMoveTree.setCurrentKey(newParentId)
        })
        this.resetNodeInputEditFlag()
      }
    },
    resetNodeInputEditFlag() {
      this.editNodeInputVisible = false;
      this.editCellToolTipVisible = false
      this.editCellErrorTip = ''
    },
    enterEditNode(data) {
      // console.log('enterEditNode', data, new Date())
      let oldEditNodeItem = this.editNodeItem;
      if(oldEditNodeItem != null){
        oldEditNodeItem.showInput = false
      }
      data.showInput = true;
      this.editNodeItem = data;
      this.editNodeInputVal = data.label;
      this.editNodeInputVisible = true;
      this.editCellToolTipVisible = false
      this.editCellErrorTip = ''
      this.forceForceEditInput(true);
    },
    focusEditNodeInput(event) {
      // event.currentTarget.select()
      this.editCellFocus = true
      this.editCellToolTipVisible =  this.editCellFocus && this.editCellErrorTip != ''
    },
    inpEditNodeInput(e) {
      try {
        this.editCellFocus = true
        if(typeof (e) != "undefined" && typeof (e.data) != "undefined" && e.data != '') {
          const selectionStart =  typeof (e.target) != "undefined" ? e.target.selectionStart : -1;
          const selectionEnd = typeof (e.target) != "undefined" ? e.target.selectionEnd : -1;
          // console.log('inpEditNodeInput', e,  e.data, selectionStart, selectionEnd, ' rt', this.validateFileName(e.data), new Date());
          if(!this.validateFileName(e.data)) {
            this.editNodeInputVal = fmtInvalidFileName(this.editNodeInputVal.trim())
            this.delayHideCellErrorTip()
            this.$nextTick(function() {
              if(typeof (selectionStart) != "undefined" && selectionStart > 0) {
                e.target.selectionStart = selectionStart - 1
                e.target.selectionEnd = selectionEnd - 1
              }
            })
          }
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.editCellToolTipVisible =  this.editCellFocus && this.editCellErrorTip != ''
      }
    },
    delayHideCellErrorTip() {
      if(this.editCellToolTipTimer) {
        window.clearTimeout(this.editCellToolTipTimer)
      }
      let vm = this;
      this.editCellToolTipTimer  = setTimeout(function () {
        vm.validateFileName(vm.editNodeInputVal)
        // console.log('editCellErrorTip', vm.editCellErrorTip, new Date())
      }, 2*1000)
    },
    //失去焦点后
    blurEditNodeInput(node, data, doSave) {
      try {
        if(typeof (doSave) == "undefined" || doSave == null) {
          doSave = false;
        }
        // console.log('blurEditNodeInput', this.$refs.editNodeInput.value, data.label, new Date())
        let editNodeInputVal = this.editNodeInputVal.trim()
        if(this.validateFileName(editNodeInputVal)) {
          data.label = this.editNodeInputVal;
          if (doSave) {
            this.renameTreeNode(data.label, data);
          }
        } else {
          this.forceForceEditInput();
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.editCellFocus = false
        this.editCellToolTipVisible = false
        this.editCellToolTipVisible =  this.editCellFocus && this.editCellErrorTip != ''
      }
    },
    validateFileName(name) {
      let errorTip = '';
      try {
        if (name != null && name.length > 0) {
          if(!validateFileName(name)) {
            errorTip = '文件名不能包含下列任何字符：<br>/ \\ ： * ？" < > |'
          } else if( name.length > 198) {
            errorTip = "字符上限最大支持≤198";
          }
        }
      } catch(t) {
        console.error(t, new Date())
      } finally {
        this.editCellErrorTip = errorTip;
      }
      return errorTip == '';
    },
    renameTreeNode(name, node) {
      let vm = this;
      if(typeof (window.delayRenameNodeInterval) != "undefined") {
        window.clearTimeout(window.delayRenameNodeInterval)
      }
      window.delayRenameNodeInterval = setTimeout(function () {
        vm.execTreeNodeRename(name, node)
      }, 100)
    },
    execTreeNodeRename(name, node) {
      let editNodeInputVal = name.trim()
      if(editNodeInputVal == '') {
        this.$message.error('不能为空');
        this.forceForceEditInput();
        return;
      }
      if(!this.validateFileName(editNodeInputVal)) {
        this.forceForceEditInput();
        return;
      }
      let vm = this;
      // console.log('execTreeNodeRename', name, node, node.parentId, new Date())
      let params = {parentId:node.parentId,name:name, 'checkRepeat':true};
      this.ucloading.showLoading();
      this.$api.post("/resapi/tw/resource-file/addDir",params).then(res => {
        // console.log('addDir',res, new Date())
        this.ucloading.hideLoading();
        if(res.success){
          this.$message.success('新建文件夹成功');
          if(typeof (node) != "undefined") {
            let oldNodeId = node.id
            node.label = res.data.name
            node.id = res.data.id
            node.name = res.data.name
            node.parentId = res.data.parentId
            node.nodeId = oldNodeId
            node.isNew = true
            node.isSaved = true
            node.showInput = false;
            if(this.moveForm.id == oldNodeId) {
              this.moveForm.id = node.id
            }
            if(this.parentId == node.parentId) {
              this.editNodeInputSaved = true
            }
            this.editNodeInputVisible = false;
          }
        } else {
          vm.$message.error(res.info);
          if(typeof (node) != "undefined") {
            this.enterEditNode(node)
          }
        }
      },function(err){
        console.error(err);
        this.ucloading.hideLoading();
      });
    }
  }
}
</script>

<style scoped>
::v-deep .confirm-repeat-dialog {
  width:420px !important;
}

.course-tree .custom-tree-node {
  position: absolute;
  padding-left: 40px;
}
.course-tree .custom-tree-node .label {
  max-width: 252px;
}
.el-tree-node__content:hover, .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #e6edf5 !important;
}
.repeat-dialog-content-panel {
  margin: 0 24px;
  font-size: 14px;
  min-height: 64px;
}
.repeat-file-list-panel {
  color:#606366;
  padding: 0 0 0 25px;
  height: 140px;
  overflow-y: auto;
}
.repeat-file-item {
  margin-top: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 20px;
  vertical-align: middle;
  max-width: 330px;
}
.res-move-folder-edit-panel .custom-icon-button{
  width: 23px;
  height: 23px;
  border: 1px solid #9DCCF5;
  background-color: transparent;
}
::v-deep  .res-move-folder-edit-panel .custom-icon-button i.iconfont  {
  color: #258CE6 !important;
  width: 9px !important;
  height: 9px !important;
  line-height: 9px !important;
  font-size: 9px !important;
}
::v-deep .res-move-folder-edit-panel .el-input--mini {
  width: 180px !important;
}
::v-deep .res-move-folder-edit-panel .el-input--mini .el-input__inner {
  height: 27px !important;
  border-radius: 0 !important;
}
::v-deep .res-move-folder-edit-panel .el-input--mini .el-input__inner:focus {
  border-color: #73B6F0 !important;
}

::v-deep .course-tree.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  border-left-color: transparent;
}
.custom--input-error-tip {
  display: inline-block;
  width: 190px;
  height: 58px;
  position: absolute;
  top:31px;
  left:0;
  line-height: 22px;
  padding: 6px 12px;
  color: #606366;
  font-size: 12px;
  background: #FFFFFF;
  border: 1px solid #DFE6ED;
  box-sizing: border-box;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 99999;
}
.custom--input-error-tip .arrow{
  width: 0;
  height: 0;
  border: 7px solid transparent;
  border-bottom-color: #fff;
  position: absolute;
  top: -14px;
  left: calc(50% - 3px);
}
</style>